export type KataId =
  | 'nage-no-kata'
  | 'katame-no-kata'
  | 'kime-no-kata'
  | 'ju-no-kata'
  | 'kodokan-goshin-jutsu'
  | 'itsutsu-no-kata'
  | 'koshiki-no-kata'

export interface Technique {
  id: string
  name: string
  /** Japanese spelling (漢字); English `name` remains the romanized / English label. */
  nameJa: string
  /** Traditional Chinese label when it differs from Japanese spelling. */
  nameZh?: string
  /** Alternate search terms; not separate catalog entries. */
  searchAliases?: string[]
}

export interface TechniqueGroup {
  id: string
  name: string
  /** Japanese spelling when the group has a Kodokan label. */
  nameJa?: string
  techniques: Technique[]
}

export interface KataTheme {
  from: string
  to: string
  text: string
}

export interface KataDefinition {
  id: KataId
  name: string
  nameJa: string
  theme: KataTheme
  groups: TechniqueGroup[]
}

export function flattenTechniques(kata: KataDefinition): Technique[] {
  return kata.groups.flatMap((group) => group.techniques)
}

export function findTechnique(
  kata: KataDefinition,
  techniqueId: string,
): Technique | undefined {
  return flattenTechniques(kata).find((t) => t.id === techniqueId)
}
